import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export const LoadingWidget = ({ fullWidth }: { fullWidth?: boolean }) => {
  return fullWidth ? (
    <div className="w-full p-10 flex justify-center">
      <div className="w-8 h-8">
        <FontAwesomeIcon
          icon={faSpinner}
          spin
          style={{ width: "100%", height: "100%" }}
        />
      </div>
    </div>
  ) : (
    <div className="w-6 h-6">
      <FontAwesomeIcon icon={faSpinner} spin />
    </div>
  )
}
